<template>
  <div class="content">
    <div class="login_wrap">
      <div class="login_wrap_left" @click="login2">
        <img class="login_wrap_left_img" src="../../assets/login.jpg"/>
      </div>
      <div class="login_wrap_right" @click="setTimer">
        <QrcodeVue class="login_wrap_right_qrcode" :class="count<=0?'gay':''" :value="qrCodeInfo" :size="270"
                   level="H"></QrcodeVue>
        <div class="login_wrap_right_zezao" v-show="count<=0" >
          <el-icon style="margin-right: 5px">
            <WarningFilled/>
          </el-icon>
          二维码已过期
        </div>
        <div class="login_wrap_right_text" @click.stop="login3">{{ text }}</div>
        <div class="login_wrap_right_foot" @click.stop="login1">v{{ version }}</div>
      </div>
    </div>

    <!-- 选择公司 -->
    <dialogBox ref="dialogBox" :center="true"></dialogBox>

  </div>
</template>

<script>
import {ver, base} from '@/utils/api.js'
import md5 from 'js-md5';
import QrcodeVue from 'qrcode.vue'
import dialogBox from '@/components/dialogBox.vue'

let timer;
export default {
  name: "login",
  components: {
    QrcodeVue,
    dialogBox
  },
  data() {
    return {
      UUID: this.$tools.getUUID(),
      // UUID: "1234",
      count: 0,
      qrCodeInfo: "",                      //二维码信息
      text: "请使用微信扫一扫登录 30秒",
      form: {
        userName: '',
        passwords: '',
        password: '',
      },
      rules: {
        // userName: [
        //     { validator: this.$verify.nothing, message: '请输入用户账号', trigger: 'blur' }
        // ],
        // passwords: [
        //     { validator: this.$verify.nothing, message: '请输入用户密码', trigger: 'blur' }
        // ],
      },
      version: ver(),
      base: base(),
      total: 0,
      //选择对话框
      dialogBoxData: {
        state: true,
        title: '请选择您的公司',
        prop: 'companyName',
        data: {},
        click: (item, index) => {
          this.switchCompany(item);
        },
        close: res => {
          this.setTimer();
        }
      },
    }
  },
  methods: {

    /**
     * 选择公司
     */
    switchCompany(item) {
      this.$store.commit("setActivePageUUID", null);
      this.$tools.setActivePageUUID().then(res => {
        //切换公司
        this.$POST1("/author/EomsRole/switchCompany", {companyId: item.companyId}).then(res => {


          //保存公司信息
          localStorage.setItem("companyInfo", JSON.stringify(item));
          //保存路由信息
          localStorage.setItem("functionPowers", JSON.stringify(res.data.functionPowers));
          this.$router.push({name: 'home'});
        });
      })
    },

    /**
     * 登陆(扫码)
     */
    login: function () {
      this.$POST1("/author/EomsUser/pcWaitWxAppLogin", {UUID: this.UUID}, false, false).then(res => {
        this.$message.success('登陆成功');
        //保存信息
        localStorage.setItem("tokenName", res.data.user.saTokenInfo.tokenName);
        localStorage.setItem("tokenValue", res.data.user.saTokenInfo.tokenValue);
        localStorage.setItem("userInfo", JSON.stringify(res.data.user));
        localStorage.setItem("sysParam", JSON.stringify(res.data.sysParam));
        //设置名称
        for (let i = 0; i < res.data.companyInfos.length; i++) {
          res.data.companyInfos[i].companyName = res.data.companyInfos[i].companySimpleName ?
              res.data.companyInfos[i].companySimpleName : res.data.companyInfos[i].companyName
        }
        //选择公司
        this.dialogBoxData.state = true;
        this.dialogBoxData.data = res.data.companyInfos;
        this.$refs.dialogBox.initData(this.dialogBoxData);
      })
    },

    /**
     * 登陆(账号密码)
     */
    login1: function () {
      if (process.env.NODE_ENV === "development") {
        this.total++;
      } else if (this.base != "https://eoms.jxkj1987.cn/business") {
        this.total++;
      }
      if (this.total >= 2) {
        this.total = 0;
        let param = {
          userName: "gp",
          password: md5("123456")
        };
        this.$POST("/author/EomsUser/loginByUserNamePassword", param).then(res => {
          this.$message.success('登陆成功');
          //保存信息
          localStorage.setItem("tokenName", res.data.user.saTokenInfo.tokenName);
          localStorage.setItem("tokenValue", res.data.user.saTokenInfo.tokenValue);
          localStorage.setItem("userInfo", JSON.stringify(res.data.user));
          localStorage.setItem("sysParam", JSON.stringify(res.data.sysParam));
          //设置名称
          for (let i = 0; i < res.data.companyInfos.length; i++) {
            res.data.companyInfos[i].companyName = res.data.companyInfos[i].companySimpleName ?
                res.data.companyInfos[i].companySimpleName : res.data.companyInfos[i].companyName
          }
          //选择公司
          this.dialogBoxData.state = true;
          this.dialogBoxData.data = res.data.companyInfos;
          this.$refs.dialogBox.initData(this.dialogBoxData);
        });
      }

    },
    login2: function () {
      if (process.env.NODE_ENV === "development") {
        this.total++;
      } else if (this.base != "https://eoms.jxkj1987.cn/business") {
        this.total++;
      }
      if (this.total >= 2) {
        this.total = 0;
        let param = {
          userName: "lyj",
          password: md5("123456")
        };
        this.$POST("/author/EomsUser/loginByUserNamePassword", param).then(res => {
          this.$message.success('登陆成功');
          //保存信息
          localStorage.setItem("tokenName", res.data.user.saTokenInfo.tokenName);
          localStorage.setItem("tokenValue", res.data.user.saTokenInfo.tokenValue);
          localStorage.setItem("userInfo", JSON.stringify(res.data.user));
          localStorage.setItem("sysParam", JSON.stringify(res.data.sysParam));
          //设置名称
          for (let i = 0; i < res.data.companyInfos.length; i++) {
            res.data.companyInfos[i].companyName = res.data.companyInfos[i].companySimpleName ?
                res.data.companyInfos[i].companySimpleName : res.data.companyInfos[i].companyName
          }
          //选择公司
          this.dialogBoxData.state = true;
          this.dialogBoxData.data = res.data.companyInfos;
          this.$refs.dialogBox.initData(this.dialogBoxData);
        });
      }

    },
    login3: function () {
      if (process.env.NODE_ENV === "development") {
        this.total++;
      } else if (this.base != "https://eoms.jxkj1987.cn/business") {
        this.total++;
      }
      if (this.total >= 2) {
        this.total = 0;
        let param = {
          userName: "cgp",
          password: md5("123456")
        };
        this.$POST("/author/EomsUser/loginByUserNamePassword", param).then(res => {
          this.$message.success('登陆成功');
          //保存信息
          localStorage.setItem("tokenName", res.data.user.saTokenInfo.tokenName);
          localStorage.setItem("tokenValue", res.data.user.saTokenInfo.tokenValue);
          localStorage.setItem("userInfo", JSON.stringify(res.data.user));
          localStorage.setItem("sysParam", JSON.stringify(res.data.sysParam));
          //设置名称
          for (let i = 0; i < res.data.companyInfos.length; i++) {
            res.data.companyInfos[i].companyName = res.data.companyInfos[i].companySimpleName ?
                res.data.companyInfos[i].companySimpleName : res.data.companyInfos[i].companyName
          }
          //选择公司
          this.dialogBoxData.state = true;
          this.dialogBoxData.data = res.data.companyInfos;
          this.$refs.dialogBox.initData(this.dialogBoxData);
        });
      }

    },
    /**
     * 设置定时器
     */
    setTimer() {
      if (this.count == 0) {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
        this.login();
        this.qrCodeInfo = "https://jxkj1987.cn/staticfile/wxQRcodeFile/eoms/uuid=" + this.UUID + "&type=0";
        console.log('this.UUID',this.UUID)
        this.count = 30;
        timer = setInterval(res => {
          if (this.count <= 0) {
            this.text = "二维码已过期,请点此刷新";
            clearInterval(timer);
            timer = null;
          } else {
            this.count--;
            this.text = "请使用微信扫一扫登录 " + this.count + "秒"
          }
        }, 1000)
      }
    },
  },
  mounted() {

    //清空缓存
    localStorage.setItem("tokenName", "");
    localStorage.setItem("tokenValue", "");
    localStorage.setItem("userInfo", "");
    localStorage.setItem("sysParam", "");
    localStorage.setItem("functionPowers", "");
    localStorage.setItem("companyInfo", "");
    //清空角色信息
    this.$store.commit("setUserInfo", {});
    //清空公司信息
    this.$store.commit("setCompanyInfo", {});
    //清空店铺信息
    this.$store.commit("setShopInfo", {});
    //清空系统参数信息
    this.$store.commit("setSysParam", {});
    //清空权限信息
    this.$store.commit("setPowerList", []);
    //清空菜单
    this.$store.commit("setMenuList", []);
    //清空tab
    this.$store.commit("setTabList", []);

    //有token,跳转直接登录
    if (this.$route.query.newObj && this.$route.query.newObj.length > 0) {
      //this.$message.success("正在使用内测版本!");
      let newObj = JSON.parse(this.$route.query.newObj);

      localStorage.setItem("tokenName", newObj.tokenName);
      localStorage.setItem("tokenValue", newObj.tokenValue);

      this.$GET("/author/EomsUser/getLoginData").then(res => {
        //保存信息
        localStorage.setItem("userInfo", JSON.stringify(res.data.user));
        localStorage.setItem("sysParam", JSON.stringify(res.data.sysParam));
        //自动选择公司
        for (let i = 0; i < res.data.companyInfos.length; i++) {
          if (res.data.companyInfos[i].companyId == newObj.companyId) {
            this.switchCompany(res.data.companyInfos[i]);
            return;
          }
        }
      })

    }
    //正常扫码登录
    else {
      //扫码计时
      this.setTimer();
    }
  }
}
</script>

<style scoped>
.content {
  position: absolute;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  min-width: 1066px;
  min-height: 708px;
  user-select: none;
  z-index: 2;
  /*background: linear-gradient(90deg, rgb(255, 255, 255), rgb(153, 153, 153), rgb(255, 255, 255));*/
  background: #d6e5ff;
}

.login_wrap {
  position: absolute;
  height: 520px;
  width: 870px;
  right: 0;
  top: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  background: #ffffff;
  border-radius: 30px;
  box-shadow: 5px 5px 9px 0 rgba(51, 51, 51, 0.3);
  overflow: hidden;
  text-overflow: ellipsis;
}

.login_wrap_left {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 50%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  color: #ffffff;
  font-size: 32px;
  font-weight: 800;
}

.login_wrap_left_img {
  position: absolute;
  left: 0;
  top: -1%;
  margin: auto;
  height: 101%;
  width: 100%;
  user-select: none;
  -webkit-user-drag: none;
}

.login_wrap_left_text {
  position: absolute;
  bottom: 34px;
  left: 0;
  right: 0;
  margin: auto;
  font-weight: 800;
  font-size: 36px;
  color: #333333;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login_wrap_right {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 50%;
  color: #ffffff;
  font-size: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.login_wrap_right_qrcode {
  position: absolute;
  left: 0;
  right: 0;
  top: 100px;
  margin: auto;
}

.gay {
  opacity: 0.3;
}

.login_wrap_right_zezao {
  position: absolute;
  height: 270px;
  width: 270px;
  left: 0;
  right: 0;
  top: 100px;
  margin: auto;
  color: #333333;
  background: rgba(234, 234, 234, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
}

.login_wrap_right_text {
  position: absolute;
  bottom: 80px;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  color: #333333;
}

.login_wrap_right_foot {
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  bottom: 10px;
  color: #909399;
  font-size: 12px;
  font-weight: 400;
  width: 53px;
}

:deep(.el-dialog__body) {
  margin-top: 20px;
}

</style>
